import { memo } from "react";
import { Row } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Bill } from "@common/types/bill";
import { toDisplayDateOnly } from "@helpers/date";
import { PeriodLockIcon } from "@components/periodLock/PeriodLockIcon";
import { useIsEntityDateLocked } from "@components/periodLock/PeriodLockDatesProvider";

interface Props {
    row: Row<ViewTableFeatures, Bill>;
}

export const LockCell = memo(({ row }: Props) => {
    const bill = row.original;
    const isLocked = useIsEntityDateLocked(
        bill.entityId,
        toDisplayDateOnly(bill.dateOnly),
    );

    if (!isLocked) {
        return null;
    }

    return (
        <PeriodLockIcon
            label="This bill is locked."
            testId="bill-list-item-lock"
        />
    );
});
LockCell.displayName = "LockCell";
